;(function() {
  'use strict'

  angular.module('core.backdrop', [])
})()
